import {useSelector}
	from "react-redux"

import avatarOscuro from "./../assets/images/user.png"
import avatarClaro  from "./../assets/images/userClaro.png"

/*
	EL MUNECO DE "SIN FOTO".

	El dibujo es una silueta maciza en #2B1C16, que es justo la tinta del modo
	claro. Sobre la barra oscura (#201A16) da 1,1 de contraste: no se ve. Aqui
	se devuelve la version clara cuando el tema es oscuro.

	El tema se PASA, no se lee del DOM. El primer intento miraba la clase de
	<html>, y esa clase la pone un efecto que corre DESPUES del primer dibujo:
	la imagen se quedaba con la version oscura y ya no se volvia a calcular.

	OJO: esto es SOLO para el dibujo por defecto. La foto real de una persona no
	se toca nunca — por eso no se resuelve con un filtro de CSS sobre el <img>,
	que invertiria tambien las fotos. (Esteban lo reporto, 2026-09-20)
*/
export const avatarPorDefecto = (temaOscuro : boolean) : string => temaOscuro ? avatarClaro : avatarOscuro

/** Para los componentes que no tienen el tema a mano. Va con los demas hooks, arriba del todo. */
export const useAvatarPorDefecto = () : string =>
	avatarPorDefecto(useSelector((estado : any) => estado.themeToggle.value))

export default avatarPorDefecto
